import { Component, OnInit } from '@angular/core';
import { AuthService } from "../core/auth.service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'eos-login',
  template: ``,
  styles: []
})
export class LoginComponent implements OnInit {

  returnUrl: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService) {
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    if (this.authService.isAuthenticated) {
      this.router.navigate([this.returnUrl]);
      return;
    }

    localStorage.setItem('returnUrl', this.returnUrl);
    this.authService.login();
  }
}
